export const sidebarItems = [
  { name: "Dashboard", path: "/", icon: "dashboard" },
  {
    name: "Master Content",
    path: "/master",
    icon: "folder_special",
    children: [
      { name: "Boards", path: "/master/boards", icon: "school" },
      { name: "Board Classes", path: "/master/board-classes", icon: "class" },
      { name: "Subjects", path: "/master/subjects", icon: "menu_book" },
      { name: "Lessons", path: "/master/lessons", icon: "auto_stories" },
    ],
  },
  { name: "Admin", path: "/admins", icon: "admin_panel_settings" },
  { name: "Users", path: "/users", icon: "manage_accounts" },
  { name: "Teachers", path: "/teachers", icon: "cast_for_education" },
  { name: "Students", path: "/students", icon: "group" },
  { name: "Banners", path: "/banners", icon: "image" },
  {
    name: "Fee",
    path: "/fee",
    icon: "payments",
    children: [
      { name: "Student Fees", path: "/student-fees", icon: "receipt_long" },
      { name: "Fee Components", path: "/fee-components", icon: "category" },
      { name: "Fee Structure", path: "/fee-structure", icon: "account_balance_wallet" },
    ],
  },
  { name: "Timetable", path: "/timetable", icon: "calendar_view_week" },
  { name: "Holidays", path: "/holidays", icon: "beach_access" },
  { name: "Events", path: "/events", icon: "celebration" },
  { name: "Subjects", path: "/subjects", icon: "menu_book" },
  { name: "Exams", path: "/exams", icon: "assignment" },
  { name: "Quiz", path: "/quiz", icon: "fact_check" },
  { name: "Library", path: "/library", icon: "local_library" },
  { name: "Doubts", path: "/doubts", icon: "quiz" },
];
